module.exports = __webpack_public_path__ + "media/images/admin/icons/timelapse-a1d6e6df44b75ca9602c65e303f665cc.png";